// components/industry-templates/LogisticsEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Truck, Package, MapPin, TrendingUp } from 'lucide-react';

export const LogisticsEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Supply Chain Solutions */}
      {industryData?.supply_chain_solutions && (
        <Card className="border-0 bg-gradient-to-br from-green-600/20 to-teal-600/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Truck className="w-8 h-8" style={{ color: theme.primary }} />
              Supply Chain Solutions
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              {industryData.supply_chain_solutions.map((solution: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl">
                  <h3 className="text-xl font-bold text-white mb-2">{solution.name}</h3>
                  <p className="text-slate-300 text-sm mb-3">{solution.description}</p>
                  <Badge style={{ backgroundColor: theme.primary }}>{solution.type}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Logistics Tech */}
      {industryData?.logistics_tech && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Package className="w-6 h-6" style={{ color: theme.primary }} />
              Logistics Technology
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-3 gap-3">
              {industryData.logistics_tech.map((tech: string, idx: number) => (
                <div key={idx} className="p-3 bg-white/5 rounded-lg text-center">
                  <div className="text-2xl mb-2">📦</div>
                  <p className="text-white font-medium text-sm">{tech}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
